<template lang="html">
    <div id="header" class="parallaxbg">
        <div class="section-overly">
            <div class="outer-text">
                <div class="middle-text">
                    <div class="inner-text">
                        <div class="modal-wrap login-page">
                            <div class="modal-bodies">
                            <div class="row modal-body">
                                <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 no-padding">
                                    <div class="login-wrap">
                                        <div class="login-header">
                                            <div class="row no-margin">
                                                <div class="col-lg-5 col-md-5 col-sm-6 col-xs-12 no-padding leftalign">
                                                    <img :src="Logo" class="img-responsive" alt=""/>
                                                </div>
                                                <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12 no-padding rightalign">
                                                    India’s largest intelligent transport management system
                                                </div>
                                            </div>
                                        </div>
                                        <div class="login-form">
                                            <img :src="MaricoLogo" class="img-responsive mb10" alt=""/>
                                            <form>

                                                <div class="login-form-text mt-20 mb20">Log in to your account</div>

                                                <!-- <span class="error" v-if="error">Email or password is incorrect</span>
                                                <span class="error" v-if="error_password">Password is incorrect</span>

                                                <div class="input-group">
                                                    <input type="text" required v-model="email" v-on:keyup.13="login">
                                                    <label>User name:</label>
                                                </div>
                                                <div class="input-group">
                                                    <input type="password" v-model="password" v-on:keyup.13="login" required>
                                                    <label>Password:</label>
                                                </div>
                                                <div class="button-style">
                                                    <button type="button" @click="login" class="primary-btn">
                                                        Log in
                                                    </button>
                                                </div> -->

                                                      <!-- <span class="mt-10 mb-10"> (or) </span> -->
                                                <div class="button-style">
                                                    <form action='http://localhost:3000/api/login/sso/google' method='get'>
                                                    <button type="submit" class="primary-btn login-btn">
                                                        Log in
                                                    </button>
                                                    </form>
                                                </div>

                                                <!-- <div>
                                                    <img :src="SignIn" class="img-responsive">
                                                </div>  -->
                                                <!-- <div class="footer-section">
                                                    <div class="forgot-pswd">
                                                        Trouble logging in?
                                                    </div>
                                                </div>    -->
                                            </form>
                                        </div>
                                        <div class="login-footer">
                                            <div class="row no-margin">
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding leftalign">
                                                    Privacy Policy
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding rightalign">
                                                    Customer Support
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-7 col-md-6 col-sm-6 col-xs-12 no-padding">
                                    <div class="radius-right">
                                        <img :src="Bg" class="img-responsive full-height" alt="" style="border-radius:0 14px 14px 0px; height: 100%;" />
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Login from '@/components/mixins/Login';
import Logo from '@common/asset/images/logo.svg';
import MaricoLogo from '@common/asset/images/maricologo.svg';
import Bg from '@common/asset/images/Sign_In.jpg';
import { required, email } from 'vuelidate/lib/validators';
import SignIn from '@common/asset/images/Google-SignIn.svg';
import _ from 'lodash';

export default {
  mixins: [Login],
  data() {
    return {
      email: null,
      password: null,
      Logo,
      MaricoLogo,
      SignIn,
      Bg,
      error: false,
      error_password: false,
    };
  },

  validations: {
    email: {
      required, email,
    },
  },

  methods: {
    async login() {
      this.$v.email.$touch();
      if (!this.$v.email.$error) {
        try {
          const data = { email: this.email, password: this.password };
          const result = await this.$store.dispatch('app/login', { data });
          if (result) {
            if (result.status === 204) {
              const result = await this.$store.dispatch('app/bootstrap');
            //   this.validateRedirect(result);
            } else if (result.status === 404) {
              this.error_password = false;
              this.error = true;
            } else if (result.status === 401) {
              this.error = false;
              this.error_password = true;
            }
          }
        } catch (err) {
          return err;
        }
      } else {
        this.error = true;
        this.error_password = false;
      }
      return true;
    },

  },
  async mounted() {
    try {
      const urlParams = new URLSearchParams(window.location.href);
      const token = urlParams.get('http://localhost:8080/login/google?pat');
      if (!_.isNil(token)) {
        localStorage.setItem('tsm-user-token', token);
        const result = await this.$store.dispatch('app/bootstrap');
        this.validateRedirect(result);
      }
    } catch (err) {
      return err;
    }
  },
};
</script>

<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

#header {
    width: 100%;
    padding: 0;
    float: left;
    height: 100vh;
}
.parallaxbg {
    background-image: url("~@common/asset/images/login_bg.jpg");
    // margin: -120px -20px -20px -20px !important;
    width: 100%;
    margin: 0 auto;
    background-position: center center;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    overflow: hidden;
}
.section-overly {
    min-height: 100vh;
    .no-padding {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .dspl_inline {
        display: inline;
    }
    .dspl_inlineblock {
        display: inline-block;
    }
    .outer-text {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
    }
    .middle-text {
        display: table;
        width: 100%;
        height: 100%;
    }
    .inner-text {
        display: table-cell;
        vertical-align: middle;
    }
    form {
        input {
            width: 100%;
            border: 0;
            border-bottom: 1px solid #9b9b9c;
            padding: 12px 0 9px;
            font-family:$fontSemibold;
            font-size: 12px;
            color: #404040;
            height:34px;
            &:focus {
                outline: none;
                border-bottom: 1px solid #003F91;
            }
        }
        .input-group {
            position: relative;
            width: 100%;
            margin: 10px 0 20px;
            label {
                content: attr(data-placeholder);
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                -webkit-transform: translate(0%, -50%);
                transform: translate(0%, -50%);
                -webkit-transition: all 0.3s ease-in-out;
                transition: all 0.3s ease-in-out;
                background-color: rgba(255, 255, 255, 0);
                color: #404040;
                font-size: 10px;
                font-weight: normal;
                line-height: 10px;
                text-transform: uppercase;
                input[type="text"],
                input[type="password"] {
                    border-bottom: 1px solid #9999a3;
                }
                input[type="text"]:focus,
                input[type="text"]:valid,
                input[type="password"]:focus,
                input[type="password"]:valid {
                    border-bottom: 1px solid #9B9B9C;
                }
                input:focus~label,
                input:valid~label {
                    top: -1px;
                    color: #404040;
                    font-size: 10px;
                    font-weight: normal;
                    line-height: 10px;
                    text-transform: uppercase;
                }
            }
        }
    }
    .modal-wrap {
        max-width: 1000px;
        margin: 0 auto;
        border-radius: 10px;
        box-shadow: 3px 3px 10px 0 #01314f;
        -webkit-transition: -webkit-transform 300ms ease-in-out;
        transition: -webkit-transform 300ms ease-in-out;
        transition: transform 300ms ease-in-out;
        transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;
        .modal-bodies {
            position: relative;
            -webkit-perspective: 1000px;
            perspective: 1000px;
        }
    }
    .login-page form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .login-wrap {
        box-shadow: 5px 0 10px 1px rgba(0, 0, 0, 0.1);
        background: #fff;
        border-radius: 4px 2px 2px 4px;
        height: 522px;
        .leftalign{
            text-align: left;
          }
          .rightalign{
            text-align:right;
          }
        .login-header {
            padding: 30px 20px 20px 20px;
            text-align: left;
        }
        .login-form {
            padding: 70px 50px;
            &-text{
              color: #404040;
              font-size: 1.2rem;
              font-weight: 600;
            }
        }
        .login-footer{
          position: fixed;
          width: 43%;
          bottom: 20px;
          padding: 0 20px;
          color: #008AFF;
          font-weight: 600;
          font-size: 8px;
        }
        .border-line {
            border: 2px solid #008AFF;
            float: left;
            width: 47px;
            margin: 0 30px;
        }
    }
    .footer-section {
        margin: 13px 0;
        .forgot-pswd {
            text-align: left;
            display: inline-block;
            color: #008AFF;
            font-weight: 600;
            font-size: 1.0rem;
        }
        .forgot-pswd h4 {
            color: #9B9B9C;
            font-size: 12px;
            margin: 0;
            line-height: 22px;
        }
    }
    .button-style {
        text-align: right;
        .primary-btn {
            cursor: pointer;
            background-color: #008AFF;
            color: #fff;
            border-color: #008AFF;
            border-radius: 2px;
            padding: 7px 25px;
            text-transform: uppercase;
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0.3px;
            outline: none;
        }
    }
    .conditions {
        padding: 0 50px 30px;
        vertical-align: bottom;
        position: relative;
        h5 {
            color: #008AFF;
            font-family:$fontSemibold;
            font-size: 10px;
            text-align: left;
        }
        p {
            color: #929292;
            font-size: 9px;
            letter-spacing: 0.23px;
            text-align: left;
        }
    }
    .error {
        display: block;
        color: #E8655D;
        font-size: 15px;
        margin: 10px;
    }
}
.radius-right {
  line-height: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 100%;
}

.login-btn {
  background-color: #077D8A !important;
  border: 1px solid #077D8A !important;
  border-radius: 4px !important;
}
.login-page{
  .modal-bodies{
    .loginbanner{
      width:100%;
      height:100%;
    }
  }
}
.mb20{
  margin-bottom: 20px;
}
.mb10{
  margin-bottom: 10px;
}
</style>
